import { get } from 'lodash';
import { call, put, takeEvery } from 'redux-saga/effects';
import * as storage from '../../core/storage';
import * as toastMsg from '../../core/toastMessages';
import {
  SHOW_DETERGENT_LOADING_MODAL,
  SHOW_DETERGENT_COMPLETE_MODAL,
  SHOW_DETERGENT_ERROR_MODAL,
} from './actions';

export function* templateSuccess() {
  yield call(toastMsg.templateDataLoaded);
}

export function* templateError() {
  yield call(toastMsg.templateDataFailed);
}

export function* siteSettingsUpdated() {
  yield call(toastMsg.siteSettingsUpdated);
}

export function* storeSelectedSite({ response }) {
  if (response.id) {
    yield call(storage.setSelectedSite, response.id);
  }
}

export function* detergentMigrationRequest() {
  yield put({ type: SHOW_DETERGENT_LOADING_MODAL });
}

export function* detergentMigrationSuccess({ response }) {
  const raw = Array.isArray(response)
    ? response
    : response?.results || response?.pods || response?.migration;
  const detergentPods = Array.isArray(raw) ? raw : [];
  yield put({ type: SHOW_DETERGENT_COMPLETE_MODAL, detergentPods });
}

function extractErrorMessage(error) {
  const message = get(error, 'message');
  if (typeof message === 'string') return message;
  const data = get(error, 'data');
  if (typeof data === 'string') return data;
  if (data && typeof data === 'object')
    return get(data, 'migration') || data.message || data.error || null;
  const err = get(error, 'error');
  if (typeof err === 'string') return err;
  if (err && typeof err === 'object')
    return get(err, 'migration') || err.message || err.error || null;
  return null;
}

export function* detergentMigrationFailure({ error }) {
  const errorMessage = extractErrorMessage(error);
  yield put({ type: SHOW_DETERGENT_ERROR_MODAL, errorMessage });
}

export function* watchSiteSettingsSagas() {
  yield takeEvery('LOAD_TEMPLATE_DATA_SUCCESS', templateSuccess);
  yield takeEvery('LOAD_TEMPLATE_DATA_FAILURE', templateError);
  yield takeEvery('FETCH_SITE_SETTINGS_SUCCESS', storeSelectedSite);
  yield takeEvery('UPDATE_SITE_SETTINGS_SUCCESS', siteSettingsUpdated);
  yield takeEvery('POST_DETERGENT_MIGRATION_REQUEST', detergentMigrationRequest);
  yield takeEvery('POST_DETERGENT_MIGRATION_SUCCESS', detergentMigrationSuccess);
  yield takeEvery('POST_DETERGENT_MIGRATION_FAILURE', detergentMigrationFailure);
}
